import { Types } from "../actions/maintenanceActions";

const DISMISSED_BANNERS_KEY = "maintenanceDismissedBanners";

const INITIAL_STATE = {
  loading: true,
  error: null,
  maintenance: null,
  isMaintenanceActive: false,
  mode: null,
  isBannerActive: false,
  bannerId: null,
  dismissedBannerIds: [],
  initialized: false,
};

const parseTime = (value) => {
  if (!value) return null;
  const time = Date.parse(value);
  return Number.isNaN(time) ? null : time;
};

const isWithinWindow = (now, startAt, endAt) => {
  if (startAt && now < startAt) return false;
  if (endAt && now > endAt) return false;
  return true;
};

const hashString = (input) => {
  if (!input) return "0";
  let hash = 0;
  for (let i = 0; i < input.length; i += 1) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(36);
};

const formatDateToken = (value) => {
  const time = parseTime(value);
  if (!time) return "na";
  return new Date(time).toISOString().slice(0, 10).replace(/-/g, "");
};

const getBannerId = (maintenance) => {
  if (!maintenance) return null;
  if (maintenance.id) return String(maintenance.id);
  const startToken = formatDateToken(maintenance.startAt);
  const endToken = formatDateToken(maintenance.endAt);
  const messageHash = hashString(maintenance.bannerMessage || "");
  return `maintenance-banner-${startToken}-${endToken}-${messageHash}`;
};

const deriveMaintenanceState = (maintenance) => {
  if (!maintenance || !maintenance.enabled) {
    return {
      isMaintenanceActive: false,
      isBannerActive: false,
      mode: null,
      bannerId: null,
    };
  }

  const now = Date.now();
  const startAt = parseTime(maintenance.startAt);
  const endAt = parseTime(maintenance.endAt);
  const bannerStartAt = parseTime(maintenance.bannerStartAt);
  const bannerEndAt = parseTime(maintenance.bannerEndAt);

  return {
    isMaintenanceActive: isWithinWindow(now, startAt, endAt),
    isBannerActive: isWithinWindow(now, bannerStartAt, bannerEndAt),
    mode: maintenance.mode || null,
    bannerId: getBannerId(maintenance),
  };
};

const readDismissedBanners = () => {
  if (typeof window === "undefined") return [];
  try {
    const stored = window.localStorage.getItem(DISMISSED_BANNERS_KEY);
    if (!stored) return [];
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    return [];
  }
};

const writeDismissedBanners = (bannerIds) => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      DISMISSED_BANNERS_KEY,
      JSON.stringify(bannerIds)
    );
  } catch (err) {
    // Ignore storage failures.
  }
};

export default function maintenanceReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.FETCH_MAINTENANCE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case Types.FETCH_MAINTENANCE_SUCCESS: {
      const maintenance = action.payload ? action.payload.maintenance : null;
      const derived = deriveMaintenanceState(maintenance);
      return {
        ...state,
        loading: false,
        initialized: true,
        error: null,
        maintenance,
        ...derived,
      };
    }
    case Types.FETCH_MAINTENANCE_FAILURE: {
      return {
        ...state,
        loading: false,
        initialized: true,
        error: action.error || "Greška pri dohvaćanju konfiguracije.",
      };
    }
    case Types.LOAD_DISMISSED_BANNERS: {
      return {
        ...state,
        dismissedBannerIds: readDismissedBanners(),
      };
    }
    case Types.DISMISS_MAINTENANCE_BANNER: {
      if (!action.payload) return state;
      const nextIds = state.dismissedBannerIds.includes(action.payload)
        ? state.dismissedBannerIds
        : [...state.dismissedBannerIds, action.payload];
      writeDismissedBanners(nextIds);
      return {
        ...state,
        dismissedBannerIds: nextIds,
      };
    }
    default:
      return state;
  }
}
